import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { useNotify } from '@/components/snackbar';
import { BUSINESS_UI_STATUS } from '@/consts/businesses';
import { BUSINESSES_QUERY_KEY, useBusiness } from '@/contexts/BusinessContext';
import { clearBusinessContext } from '@/http/axios';
import { PATH_DASHBOARD } from '@/routes/paths';
import { closeBusiness, getBusinessCreateErrorMessage } from '@/services/businesses';
import { getOperatingBusiness } from '@/utils/businessLock';
import BusinessInReviewCard from './BusinessInReviewCard';
import BusinessRejectedCard from './BusinessRejectedCard';

export default function BusinessStatusScreen() {
  const { activeBusiness, businesses, switchBusiness, isImpersonating } = useBusiness();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const notify = useNotify();

  const { mutate: deleteBusiness, isLoading: isDeleting } = useMutation({
    mutationFn: closeBusiness,
    onSuccess: async () => {
      clearBusinessContext();
      await queryClient.invalidateQueries({ queryKey: BUSINESSES_QUERY_KEY });
      notify.success('Negócio excluído.');
      window.location.assign(PATH_DASHBOARD.general.home);
    },
    onError: (error) => {
      notify.error(getBusinessCreateErrorMessage(error));
    },
  });

  const handleFix = () => {
    navigate(`${PATH_DASHBOARD.business.new}?businessId=${activeBusiness.id}`);
  };

  // switchBusiness ja recarrega a plataforma na Home (RF-09), que e o painel
  // do negocio escolhido. Sob impersonacao ele nao troca (o storage e do
  // navegador de quem impersona), entao o botao nem e oferecido.
  const operatingBusiness = isImpersonating
    ? null
    : getOperatingBusiness(businesses, activeBusiness);
  const handleBackToMain = operatingBusiness
    ? () => switchBusiness(operatingBusiness.id)
    : undefined;

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 3, md: 5 } }}>
      {activeBusiness?.uiStatus === BUSINESS_UI_STATUS.REJECTED ? (
        <BusinessRejectedCard
          business={activeBusiness}
          onFix={handleFix}
          onDelete={() => deleteBusiness({ businessId: activeBusiness.id })}
          isDeleting={isDeleting}
        />
      ) : (
        <BusinessInReviewCard
          submittedAt={activeBusiness?.submittedAt}
          onBackToMain={handleBackToMain}
        />
      )}
    </Container>
  );
}
